import { createSingleEntityStore } from '@recruitee/ngrx';
import type { StatsCounter } from '@recruitee/stats-types';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<StatsCounter>()('DashboardStatsCounter');

export {
  actions as DashboardStatsCounterActions,
  selectors as DashboardStatsCounterSelectors,
  reducer as DashboardStatsCounterReducer,
  namespace as DashboardStatsCounterNamespace,
};
